import './App.css';
import React , { useState } from 'react';
import Head from './components/Head'
import TodoForm from './components/TodoForm';
import Todolist from './components/TodoList';
import Footer from './components/Footer';
import 'font-awesome/css/font-awesome.min.css'





function App() {
  
  return (
    <div>
   <Head/>
   <TodoForm />
   <Footer />

    </div>
  );
}

export default App;
